// Anleitung „Tür von außen abschließen“ — wer hat in der App bestätigt, wer ist noch offen (Betreiber 22.10.2026).
// Wer gefragt wird, entscheidet das CRM nach der Tür-Regel (Gym-Zugang, Team). Nur Anzeige.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { integrationsAPI } from '@/lib/api';

const datum = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d) ? '' : d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

function Liste({ titel, zeilen, mitDatum }) {
  const [auf, setAuf] = useState(false);
  if (!zeilen.length) return null;
  const sichtbar = auf ? zeilen : zeilen.slice(0, 8);
  return (
    <div className="space-y-1.5">
      <p className="text-xs font-medium text-muted-foreground">{titel} ({zeilen.length})</p>
      <ul className="divide-y divide-border rounded-md border border-border">
        {sichtbar.map(z => (
          <li key={z.id} className="flex items-center justify-between gap-3 px-3 py-1.5 text-xs">
            <Link to={`/leads/${z.id}`} className="truncate hover:underline">{z.name}{z.team ? ' · Team' : ''}</Link>
            {mitDatum && <span className="text-muted-foreground tabular-nums flex-shrink-0">{datum(z.bestaetigt_am)}</span>}
          </li>
        ))}
      </ul>
      {zeilen.length > 8 && (
        <button type="button" onClick={() => setAuf(a => !a)} className="text-xs text-marke hover:underline">
          {auf ? 'Weniger anzeigen' : `Alle ${zeilen.length} anzeigen`}
        </button>
      )}
    </div>
  );
}

export default function TuerAnleitungKarte() {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState(null);
  useEffect(() => {
    integrationsAPI.getTuerAnleitung()
      .then(r => setDaten(r.data))
      .catch(e => setFehler(e?.response?.data?.detail || 'Übersicht konnte nicht geladen werden'));
  }, []);
  const gesamt = daten ? daten.bestaetigt.length + daten.offen.length : 0;
  return (
    <Card data-testid="tuer-anleitung-karte">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">Anleitung „Tür von außen abschließen“</CardTitle>
        <p className="text-[11px] text-muted-foreground">
          Die App fragt einmal alle, die die Tür per App öffnen dürfen, und lässt sie mit einem Haken bestätigen.
          {daten && ` Fassung ${daten.version}.`}
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        {fehler && <p className="text-xs text-destructive">{fehler}</p>}
        {!daten && !fehler && <p className="text-xs text-muted-foreground">Lädt …</p>}
        {daten && (
          <>
            <p className="text-sm">
              <span className="font-semibold tabular-nums">{daten.bestaetigt.length}</span> von{' '}
              <span className="tabular-nums">{gesamt}</span> haben bestätigt
              {daten.offen.length > 0 && <>, <span className="font-semibold tabular-nums">{daten.offen.length}</span> noch offen</>}.
            </p>
            {!daten.eingerichtet && <p className="text-xs text-muted-foreground">Die Türöffnung ist ausgeschaltet — die App fragt dann niemanden.</p>}
            <Liste titel="Noch offen" zeilen={daten.offen} />
            <Liste titel="Bestätigt" zeilen={daten.bestaetigt} mitDatum />
          </>
        )}
      </CardContent>
    </Card>
  );
}
